import './Process.css';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import processVideo from '../assets/Links/Process_video.mp4'; // Adjust the path as necessary
import paddy1 from '../assets/Links/Paddy_2.png';
import paddy2 from '../assets/Links/Paddy_1.png';
import step1Img from '../assets/Links/step1Img.jpg';
import step2Img from '../assets/Links/step2Img.png';  
import step3Img from '../assets/Links/step3Img.png';
import step4Img from '../assets/Links/step4Img.png';
import BackToTop from '../components/BackToTop';

const steps = [
  {
    id: 1,
    title: "Paddy Procurement",
    text: `We start at the source — working directly with trusted farmers and aggregators in rich agricultural belts of Tamil Nadu. Our procurement team hand-selects only high-grade paddy, checking for moisture content, grain maturity, and uniformity. Every lot is tested and approved before entering our mill.`,
    key: "Key Focus",
    highlight: "Quality grains, timely sourcing, ethical farming partnerships.",
    img: step1Img,
  },
  {
    id: 2,
    title: "Steaming (Parboiling Process)",
    text: `The harvested paddy is then steamed under controlled conditions to enhance its nutritional value and strengthen the grain. This traditional yet technical process helps retain the natural aroma and color while improving shelf life and cooking quality.`,
    key: "Why It Matters",
    highlight:
      "Steaming reduces breakage during milling and boosts natural taste retention.",
    img: step2Img,
  },
  {
  id: 3,
  title: "Nulling (Dehusking & Milling)",
  beforeList: `After steaming, the rice undergoes multi-stage milling using advanced machinery. This includes:`,
  list: [
    "Dehusking – removing the outer husk",
    "Polishing – enhancing texture and shine",
    "Grading – sorting by size and quality"
  ],
  afterList: `Throughout this process, the grains are passed through color sorters and metal detectors to ensure they are free from impurities, stones, and discoloration.`,
  key: "Goal",
  highlight: "Achieve soft, long, and uniform grains with no compromise on quality.",
  img: step3Img,
},

  {
    id: 4,
    title: "Packing & Storage",
    text: `Once milled, the rice is packed in food-grade, tamper-proof bags using automated machines. Each pack is sealed to retain freshness and prevent contamination. Our warehouse is temperature-controlled and hygienically maintained, ready for distribution across Tamil Nadu and beyond.`,
     packSizes: "Available Pack Sizes: 5kg | 10kg | 26kg",
    key: "Assurance",
    highlight: "ISO 9001:2015 certified, FSSAI approved, batch-tested for safety.",
    img: step4Img,
  },
];
const Process = () => {
  return (
    <div className="page-wrapper">
      <NavBar />
      <div className="process-video">
      <video
        src={processVideo}
        controls
        autoPlay
        muted
        loop
        style={{ width: "80%", borderRadius: "10px", maxHeight: "600px", minHeight: "170px" }}
      />
        </div>
      <div className="process-content">
        <div className="Overall-process-heading">
      <h1 className='accent-heading-process'>Our Rice Milling Process</h1>
          <h2 className='primary-heading'>From Field to Pack — Precision in Every Step</h2>
          <p>At Shrivel Hi-Tech Rice Industries, we believe that great rice begins with a great process. Every stage — from sourcing the right paddy to sealing the final bag — is carefully monitored, ensuring consistency, quality, and purity in every grain we deliver.</p>
             </div>
             <div className="process">  
              <div className="side-image paddy1">
                <img src={paddy1} alt="Left" className="side-image left-image" />
              </div>
              <div className="process-text-wrapper">
                 {/* Main Process Steps */}
       
      
       <div className="process-steps">
      {steps.map((step) => (
        <div className="process-row" key={step.id}>
          <div className="process-img">
            <img src={step.img} alt={step.title} />
          </div>
          <div className="process-content">
            <h2>{step.id}. {step.title}</h2>
            {step.list ? (
  <>
    <p>{step.beforeList}</p>
    <ul>
      {step.list.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
    <p>{step.afterList}</p>
  </>
) : (
  <p>{step.text}</p>
)}

                 {/* Only for Step 4: Pack Sizes */}
        {step.packSizes && (
          <p className="pack-sizes">
            <strong>{step.packSizes}</strong>
          </p>
        )}
            <p className="key-point">
              <span className="key-heading">{step.key}:</span>
              <br />
              {step.highlight.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
        
          </div>
        </div>
      ))}
    </div>
    <div className="process-note">
          <h1 className='accent-heading-process'>Our Promise</h1>
          <p><strong>From the moment we select the paddy to the time a bag reaches your kitchen, every grain goes through careful hands and smart machines. That’s the Shrivel standard — rooted in tradition, delivered with technology.</strong></p>
          </div>
                </div>
              <div className="side-image paddy2">
                <img src={paddy2} alt="Right" className="side-image right-image" />
              </div>
             </div>
        
    </div>
      <BackToTop />
    <Footer/>
    </div>
      
  );
};

export default Process;